export const DATE_LABEL = 'DD/MM/RRRR';
export const TIME_LABEL = 'GG:MM';
export const OPTIONAL_FIELD_LABEL = 'opcjonalne';
export const EMPTY_VALUE_LABEL = '-';
